import { render } from "./DonationRequired.vue?vue&type=template&id=24b24328&scoped=true"
import script from "./DonationRequired.vue?vue&type=script&lang=js"
export * from "./DonationRequired.vue?vue&type=script&lang=js"

import "./DonationRequired.vue?vue&type=style&index=0&id=24b24328&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-24b24328"

export default script